export function limitNumber(number, points = 3) {
  if (isNaN(number)) return 0;
  return parseFloat(number.toFixed(points));
}

export function getAmountInCurrencyFormat(value) {
  const fixedTwoDecimals = limitNumber(value, 2);

  const nfPKR = new Intl.NumberFormat("en-PK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return nfPKR.format(fixedTwoDecimals);
}

export function limitWeightTo(weight, points = 3) {
  if (isNaN(weight)) return 0;
  return parseFloat(weight.toFixed(points));
}
